import { FC } from "react";

interface IconProps {
  color?: string;
}

const Cursor: FC<IconProps> = ({ color = "#74B0D7" }) => (
  <svg viewBox="0 0 22 22" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.876 2.314 7.78 6.76l-3.8-5.225C3.644 1.074 3.158.78 2.63.722a1.851 1.851 0 0 0-1.465.497c-.41.379-.67.925-.723 1.519a2.45 2.45 0 0 0 .442 1.649l7.6 10.45-3.113 1.106c-.26.092-.5.243-.707.444a2.24 2.24 0 0 0-.492.722 2.507 2.507 0 0 0-.068 1.782l.128.377c.071.211.198.394.363.523.165.129.361.199.562.2l6.766.07a.935.935 0 0 0 .641-.256l8.233-7.582c.41-.378.67-.924.723-1.518a2.449 2.449 0 0 0-.442-1.65l-4.566-6.279a1.962 1.962 0 0 0-1.24-.797 1.822 1.822 0 0 0-1.396.335Z"
      stroke="none"
    />
  </svg>
);

export default Cursor;
